import { useRef, useState } from "react";
import { useEffect } from "react";
import tasksAPI from "../services/tasks";
import { ToFormatedDateWithWeekday, ToFormatedHour } from "../utils/dates";
import { Panel } from "primereact/panel";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const MeaTaskLogs = (props) => {

  const schoolId = props?.schoolId;
  const trainingId = props?.trainingId;
  const accessToken = props?.accessToken;

  const [jobId, setJobId] = useState(props?.jobId);
  const [loading, setLoading] = useState(true);
  const [hasLogs, setHasLogs] = useState(true);
  const [logsTitle, setLogsTitle] = useState(null);
  const [logs, setLogs] = useState([]);
  const [refresh, setRefresh] = useState(new Date());

  const resultsRef = useRef(null);

  useEffect(() => {
    setJobId(props?.jobId);
  }, [props?.jobId]);

  useEffect(() => {
    const fetchTaskStatus = async () => {
      tasksAPI.GetTask(schoolId, trainingId, jobId, accessToken)
        .then((data) => {
          setLogsTitle(data?.data?.message);
          setLogs(data?.data?.job_logs);
          if (data?.data?.status === "COMPLETED") {
            {
              setLoading(false);
              setJobId(null);
            }
          } else if (data?.data?.status === "FAILED") {
            {
              setLoading(false);
              setJobId(null);
            }
          }
          else {
            setTimeout(fetchTaskStatus, 1000); // Retry after 1 seconds
          }
        })
        .catch((error) => {
          console.log("error " + error);
          setJobId(null);
          setLoading(false);
        });
    };

    if (loading && jobId) {
      fetchTaskStatus();
    }

  }, [loading, jobId, refresh]);

  return (
    <>
      {hasLogs && <li className="mt-3">
        <Panel ref={resultsRef} header={logsTitle} toggleable collapsed>
          <DataTable value={logs} size="small">
            <Column field="log_type" header="Type" body={(item) =>
              <span className={item?.log_type === "WARNING" ? "text-orange-500" : (item?.log_type === "ERRR" ? "text-red-500" : "")}>{item?.log_type}</span>
            }></Column>
            <Column field="message" header="Message" ></Column>
            <Column field="created_at" header="Fait le" body={(item) => <>
              {ToFormatedDateWithWeekday(new Date(item?.created_at)) + "  " + ToFormatedHour(new Date(item?.created_at))}
            </>}></Column>
          </DataTable>

        </Panel>
      </li>}
    </>
  );
};

export default MeaTaskLogs;